import { gql } from '@apollo/client';

export const GET_TMS_PUBLISHED_TASK_BY_DRIVER_BY_DATE = gql`
  query GetTmsPublishedTaskByDriverByDate($taskDate: String!) {
    getTmsPublishedTaskByDriverByDate(taskDate: $taskDate) {
      taskId
      taskDate
      taskNumber
      taskStatusName
      wayPoints {
        taskWayPointId
        taskId
        warehouseId
        sequence
        wayPointName
        zipcode
        addressLine1
        addressLine2
        country
        state
        city
        quantity
        planArrivalTime
        planArrivalTimezone
        actualArrivalTime
        actualArrivalTimezone
        planDepartureTime
        planDepartureTimezone
        actualDepartureTime
        actualDepartureTimezone
        status
        contactName
        contactPhone
        ext
        isFinished
        isAbnormal
        waypointType
        warehouseSiteType
        photosS3Keys
        photosUrls
      }
    }
  }
`;

export interface TmsTaskWayPointWithAddressType {
  taskWayPointId: number;
  taskId?: number | null;
  warehouseId?: number | null;
  sequence: number;
  wayPointName?: string | null;
  zipcode?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  country?: string | null;
  state?: string | null;
  city?: string | null;
  quantity: number;
  planArrivalTime?: string | null;
  planArrivalTimezone?: string | null;
  actualArrivalTime?: string | null;
  actualArrivalTimezone?: string | null;
  planDepartureTime?: string | null;
  planDepartureTimezone?: string | null;
  actualDepartureTime?: string | null;
  actualDepartureTimezone?: string | null;
  status: string;
  contactName?: string | null;
  contactPhone?: string | null;
  ext?: string | null;
  isFinished: boolean;
  isAbnormal: boolean;
  waypointType?: number | null;
  warehouseSiteType?: number | null;
  photosS3Keys?: string[] | null;
  photosUrls?: string[] | null;
}

export interface TmsCompletedTaskWithWayPoints {
  taskId: number;
  taskDate: string;
  taskNumber: string;
  taskStatusName: string;
  wayPoints: TmsTaskWayPointWithAddressType[];
}

export interface GetTmsPublishedTaskByDriverByDateResponse {
  getTmsPublishedTaskByDriverByDate: TmsCompletedTaskWithWayPoints[];
}

